const API_BASE = import.meta.env.VITE_API_URL || '';

const resolveTenantCode = (tenant) =>
  tenant?.code || tenant?.codigo || tenant?.tenantCode || tenant?.id || tenant?.nombre || '';

const buildHeaders = ({ tenant, token } = {}) => {
  const headers = { 'Content-Type': 'application/json' };
  const tenantCode = resolveTenantCode(tenant);
  if (tenantCode) headers['X-Tenant'] = tenantCode;
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

const parsePayload = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.ok === false) {
    const error = new Error(payload?.message || payload?.error || 'No se pudo completar la operación.');
    error.payload = payload;
    error.status = response.status;
    throw error;
  }
  return payload.data;
};

function toQuery(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, value);
  });
  return params.toString();
}

async function apiGet(path, { tenant, token, filters } = {}) {
  const qs = toQuery(filters);
  const response = await fetch(`${API_BASE}${path}${qs ? `?${qs}` : ''}`, {
    method: 'GET',
    headers: buildHeaders({ tenant, token }),
  });
  return parsePayload(response);
}

async function apiPost(path, { tenant, token, body } = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: buildHeaders({ tenant, token }),
    body: JSON.stringify(body || {}),
  });
  return parsePayload(response);
}

export const fetchTariffWorkbench = ({ tenant, token, filters } = {}) =>
  apiGet('/api/tarifas', { tenant, token, filters });

export const saveTariffConcept = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/conceptos', { tenant, token, body });

export const saveTariffNumerator = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/numeradores', { tenant, token, body });

export const saveTariffList = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/listas', { tenant, token, body });

export const duplicateTariffList = ({ tenant, token, listId }) =>
  apiPost(`/api/tarifas/listas/${listId}/duplicar`, { tenant, token, body: {} });

export const saveTariffRule = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/reglas', { tenant, token, body });

export const previewTariffRule = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/reglas/preview', { tenant, token, body });

export const simulateTariff = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/simular', { tenant, token, body });

export const previewCoefficientAdjustment = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/procesos/coeficiente/preview', { tenant, token, body });

export const applyCoefficientAdjustment = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/procesos/coeficiente', { tenant, token, body });

export const previewMassTariffModification = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/procesos/modificacion-masiva/preview', { tenant, token, body });

export const applyMassTariffModification = ({ tenant, token, body }) =>
  apiPost('/api/tarifas/procesos/modificacion-masiva', { tenant, token, body });

export const fetchTariffAudit = ({ tenant, token, filters } = {}) =>
  apiGet('/api/tarifas/auditoria', { tenant, token, filters });

export const fetchGuideTariffSnapshots = ({ tenant, token, guiaId }) =>
  apiGet(`/api/tarifas/guias/${guiaId}/snapshots`, { tenant, token });
